export const scoreTable: { [key: string]: number } = {
  S: 100,
  A: 90,
  B: 70,
  C: 50,
  D: 30,
  F: 10
};
export const perfectScoreBonus = 10;
